import Loadable from 'react-loadable';

import PleaseWait from '~/components/loaders/please-wait';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "westpharma", webpackPrefetch: true */ './Westpharma.tsx'),
  loading: () => <PleaseWait />,
});
